import { BG_SCHEMA, SUBTITLE_SCHEMA, TITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const PERSONALIZED_FAQ_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'personalizedFaq',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    bg: BG_SCHEMA(),
    title: TITLE_SCHEMA('Faq'),
    subtitle: SUBTITLE_SCHEMA(),
    layout: 'Layout 1'
  }
}

export const beforeParseContent = target => {
  commonBeforeParseMethod(target, ['bg'])
}

export const PERSONALIZED_FAQ_SECTION = config => ({
  schema: PERSONALIZED_FAQ_SCHEMA(config),
  beforeParse: beforeParseContent
})
